module.exports = __webpack_public_path__ + "img/UTESCA-8.a4cc0408.jpg";